module.exports = function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_forceReduced.js
// module id = 1046
// module chunks = 40